module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap brand-home-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('v-image', {
    attrs: {
      "imagePath": _vm.shopDetail.imagePath && _vm.shopDetail.imagePath.imagePath,
      "height": 42
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    class: {
      fixed: _vm.isFixed
    }
  }, [_c('input', {
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": _vm.shopDetail.storeName
    },
    on: {
      "change": function($event) {},
      "click": _vm.jumpSearch
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "homeWrapper",
    staticClass: "flex-item homeWrapper"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.bannerDeatilList), function(swiperShow, swiperIndex) {
    return _c('swiper-slide', {
      key: swiperIndex
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.goPage(swiperShow.linkType, swiperShow.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": swiperShow.imagePath && swiperShow.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), (_vm.couponsList && _vm.couponsList.length) ? _c('div', {
    staticClass: "coupon"
  }, [_c('div', {
    staticClass: "coupon-recommend",
    style: ('background: url(' +
      _vm.backgroundImage +
      ') no-repeat;background-size: 100% 100%;')
  }, [_c('swiper', {
    ref: "mySwiper2",
    attrs: {
      "options": _vm.comSwiperOption
    }
  }, _vm._l((_vm.couponsList), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "coupon-item"
    }, [_c('div', {
      staticClass: "coupon-content",
      on: {
        "click": function($event) {
          return _vm.receiveCouponFn(item.couponId, item.couponType, item.isGet)
        }
      }
    }, [_c('div', {
      staticClass: "coupon-left",
      class: {
        couponColor: item.couponType == 1,
        redpacketColor: item.couponType == 2,
        finishColor: item.isGet == 1,
      }
    }, [(item.couponCate != 3) ? _c('p', {
      staticClass: "amount"
    }, [_c('samp', [_vm._v("¥")]), _vm._v("\n                  " + _vm._s(item.couponAmount) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.couponCate == 3) ? _c('p', {
      staticClass: "amount"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("discount")(item.couponDiscount)) + "\n                  "), _c('samp', [_vm._v("折")])]) : _vm._e(), _vm._v(" "), (item.couponType == 1) ? _c('p', {
      staticClass: "limit"
    }, [_vm._v("\n                  " + _vm._s(item.useAmount == 0 ?
      "不限制" :
      "满" + item.useAmount + "可用") + "\n                ")]) : _vm._e(), _vm._v(" "), (item.couponType == 2) ? _c('p', {
      staticClass: "limit"
    }, [_vm._v("\n                  " + _vm._s("剩余" +
      (parseInt(item.sendNum) - parseInt(item.recivedNum)) +
      "个红包") + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right verticalM",
      class: {
        coupons: item.couponType == 1,
        redpacket: item.couponType == 2,
        finish: item.isGet == 1,
      }
    }, [(item.isGet != 1) ? _c('span', {
      staticClass: "verticalM-box"
    }, [_vm._v("\n                  立\n                  "), _c('br'), _vm._v("\n                  即\n                  "), _c('br'), _vm._v("\n                  领\n                  "), _c('br'), _vm._v("\n                  取\n                ")]) : _vm._e(), _vm._v(" "), (item.isGet == 1) ? _c('span', {
      staticClass: "verticalM-box"
    }, [_vm._v("\n                  已\n                  "), _c('br'), _vm._v("\n                  领\n                  "), _c('br'), _vm._v("\n                  取\n                ")]) : _vm._e()])])])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "grid-three"
  }, _vm._l((_vm.promotionsShopList33), function(promotionShop3, promotion3Index) {
    return _c('mu-flexbox-item', {
      key: promotion3Index,
      staticClass: "flex-demo",
      on: {
        "click": function($event) {
          return _vm.goPage(
            promotionShop3.cates.linkType,
            promotionShop3.cates.linkTarget
          )
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShop3.imagePath && promotionShop3.imagePath.imagePath
      }
    })], 1)
  }), 1), _vm._v(" "), _vm._l((_vm.promotionsShopList44), function(promotionShop44, promotion44Index) {
    return _c('mu-flexbox', {
      key: promotion44Index,
      staticClass: "grid-one",
      on: {
        "click": function($event) {
          return _vm.goPage(
            promotionShop44.cates.linkType,
            promotionShop44.cates.linkTarget
          )
        }
      }
    }, [_c('mu-flexbox-item', {
      staticClass: "flex-demo"
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShop44.imagePath && promotionShop44.imagePath.imagePath
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "banner bannerTwo"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.promotionsShopListBanner), function(promotionShopBanner, promotionBannerIndex) {
    return _c('swiper-slide', {
      key: promotionBannerIndex
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.goPage(
            promotionShopBanner.linkType,
            promotionShopBanner.linkTarget
          )
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShopBanner.imagePath &&
          promotionShopBanner.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _vm._l((_vm.promotionsShopList66), function(promotionShop66, promotion66Index) {
    return _c('mu-flexbox', {
      key: promotion66Index,
      staticClass: "grid-one grid-one-bannerM"
    }, [_c('mu-flexbox-item', {
      staticClass: "flex-demo"
    }, [_c('v-image', {
      attrs: {
        "imagePath": promotionShop66.imagePath && promotionShop66.imagePath.imagePath
      }
    })], 1)], 1)
  }), _vm._v(" "), _vm._l((_vm.floorMsg), function(shopSetList, setIndex) {
    return (_vm.floorMsg[0].floorInfo.goods.length != 0) ? _c('div', {
      staticClass: "brand-product"
    }, [_c('a', {
      staticClass: "header",
      on: {
        "click": function($event) {
          return _vm.goPage(shopSetList.floorInfo.linkType, shopSetList.floorInfo.cateId)
        }
      }
    }, [_c('span', {
      staticClass: "floatL brandName"
    }, [_vm._v("\n          " + _vm._s(shopSetList.floorInfo && shopSetList.floorInfo.cateName) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "floatR arrow"
    }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticClass: "product"
    }, _vm._l((shopSetList.floorInfo.goods), function(shopShow, shopIndex) {
      return _c('div', {
        staticClass: "product-item square"
      }, [_c('v-image', {
        attrs: {
          "width": 250,
          "height": 250,
          "titleText": shopShow.goodsName,
          "imagePath": shopShow.imagePath && shopShow.imagePath.imagePath,
          "moneyText": shopShow.goodsPrice > 0 ?
            shopShow.goodsPrice :
            shopShow.priceDesc || '',
          "orginalCost": shopShow.unitPrice
        },
        on: {
          "eventclick": function($event) {
            return _vm.viewGoodsDetail(shopShow)
          }
        }
      }, [_c('template', {
        slot: "money"
      }, [_vm._v("\n              " + _vm._s(shopShow.goodsPrice > 0 ?
        shopShow.goodsPrice :
        shopShow.priceDesc) + "\n            ")]), _vm._v(" "), _c('template', {
        slot: "orginalCost"
      }, [_vm._v(_vm._s(shopShow.unitPrice))])], 2)], 1)
    }), 0), _vm._v(" "), _vm._l((shopSetList), function(floorBox) {
      return (shopSetList.itemType == 99) ? _c('div', {
        staticClass: "banner-product"
      }, [_c('v-image', {
        attrs: {
          "imagePath": floorBox.floorInfo &&
            floorBox.floorInfo.imagePath &&
            floorBox.floorInfo.imagePath.imagePath,
          "eventparam": _vm.item
        },
        on: {
          "eventclick": _vm.viewAdDetail
        }
      })], 1) : _vm._e()
    })], 2) : _vm._e()
  })], 2), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e157aef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/brandHome.vue
// module id = 399
// module chunks = 68